import { render, staticRenderFns } from "./commInfo.vue?vue&type=template&id=7a025ff4&scoped=true"
import script from "./commInfo.vue?vue&type=script&lang=js"
export * from "./commInfo.vue?vue&type=script&lang=js"
import style0 from "./commInfo.vue?vue&type=style&index=0&id=7a025ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a025ff4",
  null
  
)

export default component.exports